module.exports = __webpack_public_path__ + "img/en.85956142.png";